import { cloneDeep } from 'lodash';

export default class ProduitFormSiteLiesController {
	static $inject = ['$scope', 'ProduitsService', 'notification', '_'];

	constructor($scope, ProduitsService, notification, _) {
		this.$scope = $scope;
		this.ProduitsService = ProduitsService;
		this.notification = notification;
		this._ = _;
	}

	$onInit() {
		this.cloned = [];
		this.selected = [];
		this.rowsCache = new Map();
		this.refreshFiltreSitesCommerciaux();
	}

	$onDestroy() {
		//this.unregister();
	}

	async refreshFiltreSitesCommerciaux() {
		let data;
		try {
			this.rowsCache.clear();
			data = await this.ProduitsService.getSitesCommerciauxSansSociete();
			console.log(data);
			this.sites = data;
		} catch (ex) {
			data = [];
		}
		return data;
	}

	activeEditMode(siteLie) {
		siteLie.isEditMode = true;
		this.isEditMode = true;
		this.preselectFiltreSitesCommerciaux(siteLie);
	}

	async desactiveEditMode(siteLie) {
		siteLie.isEditMode = false;
		this.isEditMode = false;
		await this.loadSiteLies();
	}

	prepareRow(producteur) {
		// check pour voir si la ligne existe dans le cache
		if (this.rowsCache.has(producteur.id)) {
			return this.rowsCache.get(producteur.id);
		}

		// Récupération ou Création du modèle de liaison (site liés)
		let link = this.produit.siteLinked.find((x) => x.producteur.id === producteur.id);
		if (!link) {
			link = {
				producteur: producteur,
				entree: [],
				sortie: []
			};
			this.produit.siteLinked.push(link);
		}

		//Préparation des inputs pour le multiselect (clone de lignes + passage à selected pour ceux present dans link)
		const inputEntree = this.markSelected(this.sites, link.entree);
		const inputSortie = this.markSelected(this.sites, link.sortie);

		const rowConfig = {
			link: link,
			inputEntree: inputEntree,
			inputSortie: inputSortie,
			selectedEntree: [],
			selectedSortie: []
		};

		// Sauvegarde dans le cache
		this.rowsCache.set(producteur.id, rowConfig);
		return rowConfig;
	}

	markSelected(allSites, savedSites) {
		if (!allSites) return [];
		const clone = cloneDeep(allSites);

		if (!savedSites || savedSites.length === 0) return clone;

		clone.forEach((site) => {
			const isSelected = savedSites.some((saved) => saved.id === site.id);
			site.selected = isSelected;
		});

		return clone;
	}

	updateSelection(link, type, selection) {
		// link : l'objet de liaison (row.link) produit/producteur
		// type : 'entree' ou 'sortie'
		// selection : la liste des items retournés par le composant (outputModel)
		// On assigne la nouvelle sélection à l'objet link
		link[type] = selection;
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
